
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
import { DatePipe } from '@angular/common';
import { environment } from '../../environments/environment';



@Component({
  selector: 'app-credites',
  templateUrl: './credites.component.html',
  styleUrls: ['./credites.component.css']
})


export class CreditesComponent implements OnInit {
  	getdata
  	val
    loading = false;
    loadingnew = false;
    selectedData:any={};
    status:string
    model: any = {};
    pointsForm : FormGroup;
    backendUrl:any;

  @Input('show-modal') showModal: boolean;
  @Input('show-modal1') showModal1: boolean;
  @Input('title') title: string;
  @Input('sub-title') subTitle: string;
  @Input('cancel-label') cancelLabel: string;
  @Input('positive-label') positiveLabel: string;

  @Output('closed') closeEmitter: EventEmitter < ModalResult > = new EventEmitter < ModalResult > ();
  @Output('loaded') loadedEmitter: EventEmitter < CreditesComponent > = new EventEmitter < CreditesComponent > ();
  @Output() positiveLabelAction = new EventEmitter();
   // @ViewChild(Ng2PopupComponent) popup: Ng2PopupComponent;
   //@ViewChild('popup1') popup1: Popup;


  constructor(fb: FormBuilder,private http: Http ,private userservice: UserService,private alertService: AlertService,private datePipe: DatePipe) {

       this.pointsForm = fb.group({
      'points' : [null, Validators.required],
    })
     
  }
 
 show() {
    this.showModal = true;
  }

    hide() {
    this.showModal = false;
    this.closeEmitter.next({
      action: ModalAction.POSITIVE
    });
  }

  positiveAction() {
    this.positiveLabelAction.next(this);
    return false;
  }

  cancelAction() {
    this.showModal = false;
    this.showModal1 = false;
    this.closeEmitter.next({
      action: ModalAction.CANCEL
    });
    return false;
  }

 
  
  ngOnInit() {
     let url=window.location.hostname;
    //  if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    //  else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    //  else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}  
    //  else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let restaurant_id=currentUser.restaurant_id;

  	 var sql="SELECT * FROM fb_refer_points a left join fb_user_profiles b on a.sender_id=b.sender_id where a.restaurant_id='"+restaurant_id+"' order by a.total_points desc limit 0,15";
  	 let headers = new Headers ({  'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, method: "post" });
        
        return this.http.post(this.backendUrl+'/getdata',JSON.stringify({'query': sql}),options)
            .map(data => data.json())
            .subscribe(data => {
          this.getdata = data;
          console.log("I CANT SEE DATA HERE: ", this.getdata);
        });
  }

  public search (event, item) {
    if(item)
    {
      this.loading = true;
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let restaurant_id=currentUser.restaurant_id;
        var sql="SELECT * FROM fb_refer_points a left join fb_user_profiles b on a.sender_id=b.sender_id where a.restaurant_id='"+restaurant_id+"' and first_name like'"+item+"%"+"' order by a.total_points desc";
     let headers = new Headers ({  'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, method: "post" });
        
        return this.http.post(this.backendUrl+'/getdata',JSON.stringify({'query': sql}),options)
            .map(data => data.json())
            .subscribe(data => {
          this.getdata = data;
           this.loading = false;
          console.log("I CANT SEE DATA HERE: ", this.getdata);
        });
      }
    }  
  public refresh(){
       this.ngOnInit();
  }  
   public SelectMovie(mv: any) {
        this.selectedData = mv;
        this.show();
    }
    public ConfirmPoints(value:any){
    	this.val=value.points;
      if(this.selectedData.total_points<this.val)
      {
         $('#error').html('Total credits are less')
        $('#error').show();
        setTimeout(function(){
         $('#error').hide();
        },3000);
      }
      else{ 
    	this.hide();
    	this.showModal1 = true;
    	this.pointsForm.reset()
      }

   }
   
   public redeemPoints () {
    if(this.val)
    { 
      this.loadingnew = true;
      if(this.selectedData.total_points>this.val)
      {
      let date=new Date();
      let date_time=this.datePipe.transform(date, 'yyyy-MM-dd h:mm:ss');  
      let redeempoints=this.selectedData.total_points-this.val;  
      let sender_id=this.selectedData.sender_id;
      let restaurant_id=this.selectedData.restaurant_id;
      let data={'total_points':redeempoints}
      let sql1="INSERT INTO `fb_refer_redeem`(`sender_id`, `restaurant_id`, `points_redeem`, `date_time`) VALUES ('"+sender_id+"',"+restaurant_id+","+this.val+",now())";
      let sql="UPDATE fb_refer_points SET ? WHERE sender_id ="+sender_id;
      let headers = new Headers ({  'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers, method: "post" });
        
      this.http.post(this.backendUrl+'/update',JSON.stringify({'query': sql ,'data':data}),options)
            .map(data => data.json())
            .subscribe(data => {
           this.status = data.success;
           if(this.status=='on'){
             this.ngOnInit();
               this.hide();
               this.showModal1 = false;
               this.loadingnew = false;
               $('#success').html('Credits has been redeemed successfully')
               $('#success').show();
               setTimeout(function(){
                          $('#success').hide();
                },3000);  
             console.log("I CANT SEE DATA HERE: ", this.status);             
           }
        },
        error => {
           console.log(error);
        });
       this.http.post(this.backendUrl+'/insert',JSON.stringify({'query': sql1}),options)
            .map(data => data.json())
            .subscribe(data => {
             console.log("data",data);             
        },
        error => {
           console.log(error);
        });

      }
      else{

        $('#error_new').html('Total credits are less')
        $('#error_new').show();
        setTimeout(function(){
         $('#error_new').hide();
        },3000);
        this.loadingnew = false;                   
      }
}
}
}

export enum ModalAction { POSITIVE, CANCEL }

export interface ModalResult {
  action: ModalAction;
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/credites/credites.component.ts